/* eslint-disable no-console */
import {Col, Form, Radio, Select} from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import React, {useState} from 'react';
import {useSearchParams} from 'react-router-dom';

import {ReactComponent as YearCalender} from '../../assets/yearCalender.svg';
import {CommonErrors, TF} from '../../constants/Common';
// import {EfdbName} from '../../constants/efdbNameConstants';
import {EfdbName} from '../../constants/efdbNameConstants';
import InformativeText from '../../constants/InformativeText';
import NumberInput from '../../shared/NumberInput';
import useCompanyStore from '../../store/companyStore/companyDetailsStore';
import useJSONStore from '../../store/StaticJson/jsonStore';
import RegEx from '../../utils/FormUtils/RegEx';
import {yearSelect} from '../../utils/FormUtils/yearSelect';
import FormListComp from '../DrawerForm/Utils/FormListComp';
import {MYConfig, MYData} from '../MonthlyYearly/Interface/common';
import MonthlyYearlyDrawerForm from '../MonthlyYearly/MonthlyYearlyDrawerForm';
import {productType} from '../Table/Constants/Common';

import {yearKeyLabel} from './Constants/IP/commonKeyLabel';
import {
  ProductInfoKey,
  ProductInfoLabel
} from './Constants/Products/ProductInfoKeyLabel';
import {unitType, unitTypes} from './interface/unitChange';
import changeUnit from './Utils/changeUnit';
import {filterSelectOptions} from './Utils/commonFunctions';
import ProductFacility from './Utils/TableListForm/ProductFacilityDrawer';
import ProductInfoRaw from './Utils/TableListForm/ProductInfoRawDrawer';

const ProductInfoFormDrawerForm: React.FC<{
  data?: any;
  setSubmitDisabled: React.Dispatch<React.SetStateAction<boolean>>;
  currentStep?: number;
}> = ({data = undefined, currentStep}) => {
  const products = useJSONStore.getState().products;
  const {currency} = useCompanyStore.getState().preUnits;

  const productInfoTooltip = InformativeText?.Product;
  const yearFilter = yearSelect();
  const [searchParam] = useSearchParams();

  const {getFieldValue, setFieldValue} = useFormInstance();

  const [productUnit, setProductUnit] = useState<unitType>(
    products.find((item) => {
      return item?.value === getFieldValue([ProductInfoKey.PRODUCT_NAME]);
    })?.state ?? unitTypes.NA
  );

  const monYear: MYConfig[] = [
    {
      mainTitle: {
        key: ProductInfoKey.UNIT_PRODUCED_TF,
        title: ProductInfoLabel.UNIT_PRODUCED_TF
      },
      unit: 'No.'
    },
    {
      mainTitle: {
        key: ProductInfoKey.COST_TF,
        title: ProductInfoLabel.COST_TF,
        tooltip: productInfoTooltip?.cost_to_production
      },
      unit: currency
    },
    {
      mainTitle: {
        key: ProductInfoKey.SELLING_TF,
        title: ProductInfoLabel.SELLING_TF,
        tooltip: productInfoTooltip?.selling_price
      },
      unit: currency
    }
  ];

  return (
    <>
      {currentStep === 0 && (
        <>
          <Col className="gutter-row">
            <Form.Item
              name={yearKeyLabel.key}
              label={yearKeyLabel.label}
              labelCol={{span: 24}}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(yearKeyLabel.label)
                }
              ]}
              initialValue={searchParam.get('selectedYear')}
            >
              <Select
                placeholder={yearKeyLabel.label}
                options={yearFilter}
                suffixIcon={<YearCalender />}
                onChange={() => {
                  setFieldValue(ProductInfoKey.FACILITIES, [{}]);
                }}
                disabled={data !== undefined}
              />
            </Form.Item>
          </Col>
          <Col className="gutter-row">
            <Form.Item
              name={ProductInfoKey.PRODUCT_NAME}
              rules={[
                {
                  required: true,
                  message: CommonErrors.mandatory(ProductInfoLabel.PRODUCT_NAME)
                }
              ]}
              label={ProductInfoLabel.PRODUCT_NAME}
              initialValue={undefined}
              labelCol={{span: 24}}
              validateFirst
              hasFeedback
            >
              <Select
                showSearch
                className="input"
                placeholder={`Enter ${ProductInfoLabel.PRODUCT_NAME}`}
                filterOption={filterSelectOptions}
                options={products.filter(
                  (item: any) => item?.dbName === EfdbName.eeio
                )}
                disabled={data !== undefined}
                onChange={(_, option) => {
                  setProductUnit(option?.state);
                }}
              />
            </Form.Item>
          </Col>
          <Col className="gutter-row">
            <Form.Item dependencies={[ProductInfoKey.PRODUCT_NAME]} noStyle>
              {({getFieldValue}) => {
                return (
                  (products.find(
                    (formatItem: any) =>
                      formatItem.value ===
                      getFieldValue([ProductInfoKey.PRODUCT_NAME])
                  )?.state ?? unitTypes.NA) !== unitTypes.NA && (
                    <Form.Item
                      name={ProductInfoKey.VOLUME}
                      label={ProductInfoLabel.VOLUME}
                      rules={[
                        {
                          pattern: RegEx.nonDecimal,
                          message: CommonErrors.nonDecimalNonNegative
                        }
                      ]}
                      labelCol={{span: 24}}
                      validateFirst
                      hasFeedback
                    >
                      <NumberInput
                        addonAfter={changeUnit(productUnit)}
                        placeholder={`Enter ${ProductInfoLabel.WEIGHT}`}
                        isFormatted={true}
                      />
                    </Form.Item>
                  )
                );
              }}
            </Form.Item>
          </Col>
          <Col className="gutter-row">
            <Form.Item
              name={ProductInfoKey.PRODUCT_TYPE}
              label={ProductInfoLabel.PRODUCT_TYPE}
              rules={[]}
              labelCol={{span: 24}}
              initialValue={productType?.[0].value}
            >
              <Radio.Group
                buttonStyle="solid"
                className="toggle"
                style={{width: '202px'}}
              >
                {productType.map(({value, label}, id) => {
                  return (
                    <Radio.Button key={id} value={value}>
                      {label}
                    </Radio.Button>
                  );
                })}
              </Radio.Group>
            </Form.Item>
          </Col>
          <div className="stepTitle" style={{margin: '2rem 0 0 0'}}>
            Raw Materials
          </div>
          <FormListComp
            mainName={ProductInfoKey.RAW_MATERIAL_DATA}
            formComponent={<ProductInfoRaw />}
          />
        </>
      )}
      {currentStep === 1 && (
        <FormListComp
          mainName={ProductInfoKey.FACILITIES}
          formComponent={<ProductFacility />}
        />
      )}
      {currentStep === 2 && (
        <MonthlyYearlyDrawerForm
          config={monYear}
          data={getFieldValue(TF) as MYData[]}
        />
      )}
    </>
  );
};

export default ProductInfoFormDrawerForm;
